import React from 'react'
import {useTranslation} from 'react-i18next'
import classNames from 'classnames'
import {COMPANY_NAME} from '@/constants/app'
import {EcospendBlock, EcospendField} from '..'
import {EcospendPayeeBlockProps} from './props'
import styles from './EcospendPayeeBlock.scss'

export const EcospendPayeeBlock: React.FC<EcospendPayeeBlockProps> = ({payee, className}) => {
    const {t} = useTranslation()
    return (
        <div className={classNames(styles.ecospendPayeeBlock, className)}>
            <EcospendBlock className={styles.block}>
                <EcospendField label={t('EcospendPayeeBlock.payee')}>
                    {payee || t('EcospendPayeeBlock.unknown')}
                </EcospendField>
            </EcospendBlock>
            <EcospendBlock className={styles.block}>
                <EcospendField label={t('EcospendPayeeBlock.processor')}>
                    {t('EcospendPayeeBlock.processorValue', {companyName: COMPANY_NAME})}
                </EcospendField>
            </EcospendBlock>
        </div>
    )
}
